import {
  ResetPasswordUrl,
  UpdatePasswordUrl
} from '../utils/commonUrls'
import {
  genericPostRequestToApi,
  genericPutRequestToApi
} from '../utils/genericRequests'

const resetPasswordRequest = (data) => {
  return genericPostRequestToApi(ResetPasswordUrl(), data)
}
const updatePasswordRequest = (data) => {
  return genericPutRequestToApi(UpdatePasswordUrl(), data)
}

export {
  resetPasswordRequest,
  updatePasswordRequest
}
